export default __webpack_public_path__ + "static/media/github.e8c48bc7.svg";